<template>
  <div class="home">
    <div class="title">
      <img src="./logo_icon.svg" alt="" srcset="" />
      <el-dropdown class="user-wrapper" @command="handleCommand">
        <div class="user-content">
          <p class="username">{{ $store.state.username }}</p>
          <el-avatar
            class="user"
            style="color: #fff; background-color: #b50d08"
          >
            N
          </el-avatar>
        </div>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="changePassword">
            Change Password
          </el-dropdown-item>
          <el-dropdown-item command="logout">Logout</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!--<h2>Lenovo Credit Platform</h2>-->
      <div class="home-menu-wrapper">
        <el-menu
          mode="horizontal"
          class="home-menu"
          :default-active="activeMenuName"
        >
          <template v-for="item in menus">
            <child-menu v-if="item.children" :data="item" :key="item.id" />
            <el-menu-item
              v-else
              @click="$router.push({ path: item.url })"
              :index="item.url"
              :key="item.id"
            >
              {{ item.name }}
            </el-menu-item>
          </template>
        </el-menu>
      </div>
      <div class="router_Search" v-if="$store.state?.btnList?.SearchBar">
        <el-select
          v-model="routerSearch"
          class="router_Search_color"
          @change="changeRouterSearch"
        >
          <el-option label="Customer Name" :value="1"></el-option>
          <el-option label="Customer #" :value="2"></el-option>
          <el-option label="Trans #" :value="3"></el-option>
        </el-select>
        <el-select
          v-model="nameorid"
          v-if="routerSearch == 1"
          filterable
          style="width: 227px"
          clearable
          remote
          :placeholder="INplaceholder"
          reserve-keyword
          :remote-method="remoteMethod"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          v-model="nameorid"
          v-if="routerSearch == 2"
          filterable
          style="width: 227px"
          :placeholder="INplaceholder"
          clearable
          remote
          reserve-keyword
          :remote-method="remoteMethod"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.code"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          v-model="nameorid"
          v-if="routerSearch == 3"
          filterable
          style="width: 227px"
          :placeholder="INplaceholder"
          clearable
          remote
          reserve-keyword
          :remote-method="remoteMethod"
          @change="handleTransChange"
        >
          <el-option
            v-for="item in options"
            :key="item.bpmId"
            :label="item.bpmId"
            :value="item.bpmId"
          ></el-option>
        </el-select>

        <el-button
          style="r_btn"
          icon="el-icon-search"
          @click="goCustomerManagemen"
        ></el-button>
      </div>
    </div>
    <div class="content">
      <router-view />
    </div>

    <!-- AI聊天图标 -->
    <div class="ai-chat-icon" @click="goToAiChat" v-if="hasAiRobotPermission">
      <img src="@/assets/images/ai-icon.png" alt="AI Chat" />
    </div>

    <el-dialog
      title="Change Password"
      width="520px"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <el-card shadow="false">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          inline
          label-width="136px"
        >
          <el-form-item label="Old Password" prop="oldPassword">
            <el-input
              v-model="form.oldPassword"
              show-password
              style="width: 290px"
            ></el-input>
          </el-form-item>
          <el-form-item label="New Password" prop="password">
            <el-input
              v-model="form.password"
              show-password
              style="width: 290px"
            ></el-input>
          </el-form-item>
          <el-form-item label="Confirm Password" prop="confirmPassword">
            <el-input
              v-model="form.confirmPassword"
              show-password
              style="width: 290px"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-card>
      <div slot="footer">
        <customize-button
          style="margin-right: 20px"
          @click="dialogVisible = false"
        >
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handleClickPasswordBtn">
          Save
        </customize-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ChildMenu from './child-menu'
import {
  changePassword,
  logout,
  getTableData,
  getRecentLog,
  getTranList,
} from './api'

export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input a password!'))
      } else {
        if (this.form.confirmPassword !== '') {
          this.$refs.form.validateField('confirmPassword')
        }
        callback()
      }
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the password again!'))
      } else if (value !== this.form.password) {
        callback(new Error('The two passwords are inconsistent!'))
      } else {
        callback()
      }
    }
    const searchParams = {
      business: '',
      cca: '',
      code: '',
      country: '',
      creditManager: '',
      geo: '',
      name: '',
      region: '',
    }
    return {
      options: [],
      searchParams,
      routerSearch: 1,
      INplaceholder: 'Enter Customer Name...',
      nameorid: '',
      activeMenuName: '/' + window.location.hash.slice(1).split('/')[1],
      dialogVisible: false,
      form: {
        password: '',
        confirmPassword: '',
        oldPassword: '',
      },
      rules: {
        oldPassword: [
          {
            required: true,
            message: 'Please type in the old password.',
            trigger: 'blur',
          },
        ],
        password: [
          { required: true, validator: validatePass, trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, validator: validatePass2, trigger: 'blur' },
        ],
      },
    }
  },
  mounted() {
    this._getTableData(this.searchParams)
  },
  methods: {
    handleTransChange(value) {
      const target = this.options.filter(item => item.bpmId === value)[0]
      this.transTarget = target
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        if (this.routerSearch === 1) {
          const params = {
            name: query,
          }
          this._getTableData(params)
        } else if (this.routerSearch === 2) {
          const params = {
            code: query,
          }
          this._getTableData(params)
        } else if (this.routerSearch === 3) {
          const params = {
            bpmId: query,
          }
          this.getTranList(params)
        }
      } else {
        this.options = []
      }
    },
    async getTranList(params = {}) {
      try {
        this.options = []
        const { data } = await getTranList(params)
        this.options = data
      } catch (err) {
        console.error(err)
      }
    },
    changeRouterSearch(value) {
      if (value === 1) {
        this.INplaceholder = 'Enter Customer Name...'
        this._getTableData()
      } else if (value === 2) {
        this.INplaceholder = 'Enter Customer #...'
        this._getTableData()
      } else if (value === 3) {
        this.INplaceholder = 'Enter Trans #...'
        this.getTranList()
      }
      this.nameorid = ''
    },

    async _getTableData(params = {}) {
      try {
        this.options = []
        const { data } = await getTableData(params)
        this.options = data
      } catch (err) {
        console.error(err)
      }
    },
    // 搜索后跳转customer management页面
    async goCustomerManagemen() {
      if (this.routerSearch === 3) {
        if (this.transTarget == null) {
          this.$message.warning('Please select trans #.')
        } else {
          const data = this.options.filter(
            item => item.bpmId === this.nameorid,
          )[0]
          if (this.$store.state.source === 1) {
            let routeUrl = this.$router.resolve({
              path: `/credit-management/credit-audit/single-audit?bpmId=${this.transTarget.bpmId}&companyCode=${this.transTarget.companyCode}`, // 对应路由
            })
            window.open(routeUrl.href, '_blank')
          } else {
            console.log(data)
            if (Object.keys(data).length && [6, 8].includes(data.status)) {
              // 二次审批
              let routeUrl = this.$router.resolve({
                path: `/credit-management/css-audit/css-second-audit?bpmId=${data.bpmId}&companyCode=${data.companyCode}&status=${data.status}`, // 对应路由
              })
              window.open(routeUrl.href, '_blank')
            } else {
              let routeUrl = ''
              if (data.status === 2) {
                routeUrl = this.$router.resolve({
                  path: `/credit-management/css-audit/css-final-audit?bpmId=${this.transTarget.bpmId}&companyCode=${this.transTarget.companyCode}`, // 对应路由
                })
              } else {
                routeUrl = this.$router.resolve({
                  path: `/credit-management/css-audit/single-audit?bpmId=${this.transTarget.bpmId}&companyCode=${this.transTarget.companyCode}`, // 对应路由
                })
              }
              window.open(routeUrl.href, '_blank')
            }
          }
        }
      } else {
        if (this.nameorid) {
          await getRecentLog({ companyId: this.nameorid })
          let routeUrl = this.$router.resolve({
            path: `/customer-management/${this.nameorid}/info`, // 对应路由
          })
          window.open(routeUrl.href, '_blank')
        } else {
          this.$message.warning(
            `${
              this.routerSearch === 1
                ? 'Please select customer name.'
                : 'Please select customer #.'
            }`,
          )
        }
      }
    },
    async handleCommand(command) {
      if (command === 'logout') {
        try {
          await logout()
          this.$store.commit('clearAllStore')
          this.$message.success('success')
          await this.$router.push('/user/login')
        } catch (err) {
          console.error(err)
        }
      } else if (command === 'changePassword') {
        this.dialogVisible = true
      }
    },
    async handleClickPasswordBtn() {
      try {
        const valid = await this.$refs.form.validate()
        if (valid) {
          await changePassword({ ...this.form })
          this.$message.success('success')
          await this.$router.push('/user/login')
        }
      } catch (err) {
        console.error(err)
      }
    },
    handleDialogClose() {
      this.$refs.form.resetFields()
    },
    // 跳转到AI聊天页面
    goToAiChat() {
      this.$router.push('/ai/ai-chat')
    },
  },
  watch: {
    $route(newValue) {
      let { path } = newValue
      path = '/' + path.split('/')[1]
      if (path !== this.activeMenuName) this.activeMenuName = path
    },
  },
  computed: {
    ...mapState({
      menus: state => state.menus,
    }),
    hasAiRobotPermission() {
      // 检查 menus 中是否有子菜单项的 name 等于 "AI Robot"
      return this.menus.some(menu => {
        if (menu.children && Array.isArray(menu.children)) {
          return menu.children.some(child => child.name === 'AI Robot');
        }
        return false
      })
    },
  },
  components: { ChildMenu },
}
</script>

<style scoped lang="scss">
:deep(.router_Search_color .el-input .el-input__inner) {
  width: 150px;
  background-image: linear-gradient(46deg, #fe7301 0%, #e41e20 100%);
  box-shadow: 0 4px 16px 0 rgba(158, 2, 32, 0.1);
  border: 0;
  text-align: center;
  border-radius: 4px;
  color: #fff;
}
:deep(.router_Search) {
  position: absolute;
  right: 10px;
  bottom: 66px;
}

.home {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: #f4f3f9;
  .title {
    position: relative;
    width: 100%;
    height: 180px;
    background: url('./topbar-bg.jpg') no-repeat;
    background-size: 100% 100%;
    /* shift background slightly left */
    background-position: -30px center;
    padding-left: 32px;
    box-sizing: border-box;
    img {
      margin: 25px 10px;
      width: 250px;
    }
    .user-wrapper {
      position: absolute;
      top: 16px;
      right: 32px;
      cursor: pointer;
      .user-content {
        color: #fff;
        height: 40px;
        display: flex;
        .username {
          font-size: 15px;
          line-height: 40px;
          margin-right: 21px;
        }
        .user {
          width: 40px;
          height: 40px;
          line-height: 40px;
          font-size: 20px;
          font-weight: 700;
        }
      }
    }
  }
  .customize-button-medium {
    height: 32px;
    padding: 8px 16px;

    span {
      font-size: 14px;
    }
  }
  .home-menu-wrapper {
    position: absolute;
    bottom: 20px;
    width: calc(100% - 32px);
    display: flex;
    .home-menu {
      border-bottom: none;
      background-color: transparent;
      li {
        height: 44px;
        line-height: 44px;
        font-size: 14px;
        color: #fff;
      }

      :deep(.el-submenu__title) {
        font-size: 14px;
        color: #fff;
        height: 44px;
        line-height: 44px;
        border-bottom: none;

        &:hover {
          background-color: transparent;
        }
      }
      :deep(.el-submenu__icon-arrow) {
        display: none;
      }
      :deep(.is-active) {
        border-bottom: none;
        background-image: linear-gradient(46deg, #fe7301 0%, #af0409 100%);
        border-radius: 8px;
      }
      .el-menu-item {
        padding: 0 8px;
        &:hover {
          background-color: transparent;
        }
      }
    }
  }
  .content {
    padding: 32px;
  }
  .routerSearch {
    position: absolute;
    left: 920px;
    bottom: 0px;
  }
  :deep(.router_Search .el-button) {
    border: 0;
    width: 63px;
    background-image: linear-gradient(46deg, #fe7301 0%, #e41e20 100%);
    box-shadow: 0 4px 16px 0 rgba(158, 2, 32, 0.1);
    border-radius: 4px;
    color: #fff;
  }

  // AI聊天图标样式
  .ai-chat-icon {
    position: fixed;
    bottom: 200px;
    right: 30px;
    width: 56px;
    height: 56px;
    border-radius: 16px;
    background: #ffffff;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    border: 1px solid rgba(0, 0, 0, 0.06);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      background: #f8f9fa;
    }

    &:active {
      transform: translateY(0);
    }

    img {
      width: 32px;
      height: 32px;
      margin: 0;
    }
  }
}
</style>
